import { useState } from 'react';
import { useLocalization } from '@/hooks/use-localization';

type InfoButtonProps = {
    infoText: string;
    label: string;
};

export const InfoButton = ({ label, infoText }: InfoButtonProps) => {
    const [showInfoText, setShowInfoText] = useState(false);
    const { localize } = useLocalization();

    return (
        <div className="r-flex r-flex-col">
            <button
                type="button"
                aria-expanded={showInfoText}
                aria-label={`${label} - ${localize('info-button-label')}`}
                className="r-flex r-cursor-pointer r-items-center r-space-x-2 r-border-0 r-bg-transparent r-p-0 r-text-left"
                onClick={() => setShowInfoText(val => !val)}
                onKeyDown={e => {
                    if (e.key === 'Escape' && showInfoText) {
                        setShowInfoText(false);
                    }
                }}
            >
                <span className="r-flex r-h-4 r-w-4 r-flex-shrink-0 r-items-center r-justify-center">
                    <img src="/assets/icons/info.svg" alt="" aria-hidden="true" />
                </span>
                <span>{label}</span>
            </button>
            {showInfoText && infoText && (
                <div role="status" className="r-mt-4 r-w-full r-bg-gray-100 r-p-3 r-text-sm">
                    <p>{infoText}</p>
                </div>
            )}
        </div>
    );
};
